<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" @click.stop>
                <div class="dialog-title">{{$t('message.item_e2e_encryption_setting')}}</div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="120px" class="dialog-form-item" :model="inputForm" :rules="rules" ref="inputForm">
                        <el-form-item>
                            <span slot="label">{{$t('message.item_e2e_encryption')}}</span>
                            <el-switch active-color="#5171cb" v-model="inputForm.encryption" @change="handleOptionChange()"></el-switch>
                        </el-form-item>
                        <el-form-item v-if="inputForm.encryption" prop="password">
                            <span slot="label">{{$t('message.item_password')}}</span>
                            <el-input style ="width:360px" v-model="inputForm.password" show-password>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="() => {$emit('update:show', false); $emit('onCancel')}" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="onSave()" :disabled="disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonValidate from '../../../common-validate.js';

export default {
    data() {
        var validatePass = (rule, value, callback) => {
            let validateResult = commonValidate.validateItem(this.$i18n, "password", value)
            if (validateResult.valid) {
                callback()
            } else {
                callback(new Error(validateResult.message))
            }
        };
        return {
            inputForm : {
                encryption: false,
                password: null
            },
            rules: {
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ]
            },
            disableButton: true
        };
    },
    methods: {
        handleOptionChange: function() {
            this.disableButton = (this.inputForm.encryption == this.encryption);
        },
        onSave : function() {
            this.$refs['inputForm'].validate((valid) => {
              if (valid) {
                 this.$emit('onSave', this.inputForm.encryption, this.inputForm.password)
              }
            });
        }
    },
    created: function() {
        this.inputForm.encryption = this.encryption;
    },
    props: {
        encryption : {
            type: Boolean,
            default: false
        }
    }
}
</script scoped>

<style scoped>
.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

</style>
